import React, { useState, useEffect } from 'react';
import PlayerAvatar from './PlayerAvatar';

const ROLE_LABELS = { banker: 'Банкир', warehouse: 'Работник склада', seller: 'Продавец', moderator: 'Модератор' };

function pluralize(n, one, few, many) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}

function PlayersList() {
  const [players, setPlayers] = useState([]);
  const [search, setSearch] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/players')
      .then(res => res.json())
      .then(data => setPlayers(data.players || []))
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  const formatLastSeen = (utcStr) => {
    if (!utcStr) return 'Никогда не заходил';
    const date = new Date(utcStr.replace(' ', 'T') + 'Z');
    const diffMs = Date.now() - date.getTime();
    const diffMin = Math.floor(diffMs / 60000);

    if (diffMin < 1) return 'только что';
    if (diffMin < 60) return `${diffMin} ${pluralize(diffMin, 'минуту', 'минуты', 'минут')} назад`;

    const diffHours = Math.floor(diffMin / 60);
    if (diffHours < 24) return `${diffHours} ${pluralize(diffHours, 'час', 'часа', 'часов')} назад`;

    return date.toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', dateStyle: 'short', timeStyle: 'short' });
  };

  const toggleExpand = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  const filtered = players.filter(p =>
    (p.mc_nickname || '').toLowerCase().includes(search.toLowerCase())
  );

  const onlineCount = players.filter(p => p.is_online).length;

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Список игроков</h2>
      <p style={{ marginTop: '-10px', color: 'var(--text-secondary)', fontSize: '14px' }}>
        Онлайн сейчас: <b style={{ color: 'var(--success)' }}>{onlineCount}</b>
      </p>

      <input
        type="text"
        placeholder="Поиск по никнейму..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {loading ? (
        <div className="card" style={{ textAlign: 'center', color: 'var(--text-secondary)' }}>Загрузка...</div>
      ) : filtered.length === 0 ? (
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)' }}>Игроки не найдены</p>
      ) : (
        filtered.map(p => (
          <div key={p.tg_id} className="card" onClick={() => toggleExpand(p.tg_id)} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <PlayerAvatar nickname={p.mc_nickname} size={28} />
                <span className="player-name">{p.mc_nickname}</span>
              </span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: p.is_online ? 'var(--success)' : 'var(--text-secondary)' }}>
                <span style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: p.is_online ? 'var(--success)' : 'var(--border-strong)',
                  display: 'inline-block'
                }}></span>
                {p.is_online ? 'В сети' : formatLastSeen(p.last_login)}
              </span>
            </div>

            {expandedId === p.tg_id && (
              <div style={{ marginTop: '15px', fontSize: '14px', color: 'var(--text-secondary)', borderTop: '1px solid var(--border)', paddingTop: '10px', lineHeight: '1.6' }}>
                <p style={{ margin: '5px 0' }}>
                  <b>Банковские счета:</b> {p.accounts && p.accounts.length > 0 ? p.accounts.map(n => `#${n}`).join(', ') : 'Нет счетов'}
                </p>
                <p style={{ margin: '5px 0' }}><b>Почта на сервере:</b> {p.postal_address || 'Не указана'}</p>
                <p style={{ margin: '5px 0' }}>
                  <b>Telegram:</b>{' '}
                  {p.tg_username && p.tg_username !== 'Без имени' ? (
                    <a
                      href={`https://t.me/${p.tg_username.replace('@', '')}`}
                      target="_blank"
                      rel="noreferrer"
                      onClick={e => e.stopPropagation()}
                      style={{ color: 'var(--accent-dark)', textDecoration: 'none' }}
                    >
                      @{p.tg_username.replace('@', '')}
                    </a>
                  ) : 'Нет юзернейма'}
                </p>
                <p style={{ margin: '5px 0' }}>
                  <b>Роли:</b> {[p.is_admin ? 'Администратор' : null, ...(p.roles || []).map(r => ROLE_LABELS[r])].filter(Boolean).join(', ') || 'Игрок'}
                </p>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default PlayersList;

